import { Chip } from '@mui/material';
import { MessageStatus } from 'common/dto-types/message-dto';

const MessageStatusCell = ({ value }: { value: MessageStatus }): JSX.Element => {
    switch (value) {
        case MessageStatus.Draft:
            return <Chip color="warning" label="Draft" size="small" variant="light" />;
        case MessageStatus.Scheduled:
            return <Chip color="primary" label="Scheduled" size="small" variant="light" />;
        case MessageStatus.Publishing:
            return <Chip color="secondary" label="Publishing" size="small" variant="light" />;
        case MessageStatus.Published:
            return <Chip color="success" label="Published" size="small" variant="light" />;
        case MessageStatus.Removed:
            return <Chip color="error" label="Removed" size="small" variant="light" />;
        case MessageStatus.Recalled:
            return <Chip color="default" label="Recalled" size="small" variant="light" />;
        default:
            return <p>Unknown</p>;
    }
};

export default MessageStatusCell;
